import React from 'react';
import { retry, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { Creators as ParametroActions } from '../ducks/parametro';

import { ParametroAPI } from '../../services/api';
import { WarningToast, SuccessToast } from '../../components/molecules/Toast';
import modal from '../../context/TriggerModalContext';
import history from '../../services/history';

export function* getParametrosRequest(action) {
  try {
    const response = yield retry(5, 2000, ParametroAPI.get, `/listParameters`);

    const { success, message, data } = response.data;
    yield put(ParametroActions.success(success, message, data));
  } catch (error) {
    yield put(ParametroActions.getError(error));
  }
}

export function* patchParametrosRequest(action) {
  try {
    const { idParametrizacao, data } = action;
    const response = yield retry(
      5,
      2000,
      ParametroAPI.patch,
      `/updateParameter/${idParametrizacao}`,
      { ...data }
    );

    const { success, message } = response.data;
    yield put(ParametroActions.success(success, message));
    modal.success(response.data.message, () => {
      history.push('/novo/parametros');
    });
  } catch (error) {
    toast.error(<WarningToast>{error.message}</WarningToast>);
  }
}
